const ANIMATION_PERCENTAGE = {
  text: 0.4,
};

module.exports.default = module.exports.ANIMATION_PERCENTAGE =
  ANIMATION_PERCENTAGE;
